<template>
  <div class="flex flex-col gap-0.5">
    <slot v-for="transport in transports">
      <container-transport
        v-if="!transport.hidden"
        :key="transport.key"
        :detail="options.opsDisplay"
        :curApptDate="options.curApptDate"
        :viewTasks="$store.settings.calendarTaskDisplay"
        :viewPickup="$store.settings.calendarPickupInstrDisplay"
        :viewEmptyReturn="$store.settings.calendarEmptyReturnInstrDisplay"
        :container="item"
        :item="transport"
      />
    </slot>
  </div>
</template>

<script>
export default {
  name: "legacy-routes",
  props: {
    item: Object,
    options: Object,
  },
  computed: {
    transports() {
      return this._.sortBy(this.item.transports, "sequence");
    },
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
